import { useVenueDataContext } from '@/VenueDataLoader'

export function useAnalyticsSettings() {
  const { analyticsSettings } = useVenueDataContext()
  return analyticsSettings
}
